export const dataImporterSelectionTypes = {
    'PAGE_INIT': 'DATA_IMPORTER_SELECTION_PAGE_INIT',
    'PAGE_NEXT': 'DATA_IMPORTER_SELECTION_PAGE_NEXT',
    'PAGE_PREVIOUS': 'DATA_IMPORTER_SELECTION_PAGE_PREVIOUS',
    'PAGE_REQUEST': 'DATA_IMPORTER_SELECTION_PAGE_REQUEST',
    'PAGE_SUCCESS': 'DATA_IMPORTER_SELECTION_PAGE_SUCCESS',
    'PAGE_ERROR': 'DATA_IMPORTER_SELECTION_PAGE_ERROR',
    'TOGGLE_SELECTION': 'DATA_IMPORTER_SELECTION_TOGGLE_SELECTION',
    'CLEAR_SELECTION': 'DATA_IMPORTER_SELECTIONCLEAR_SELECTION',
    'TOGGLE_ALL': 'DATA_IMPORTER_SELECTION_TOGGLE_ALL',
    'ADD_FILTER': 'DATA_IMPORTER_SELECTION_ADD_FILTER',
    'REMOVE_FILTER': 'DATA_IMPORTER_SELECTION_REMOVE_FILTER',
    'RESET_FILTERS': 'DATA_IMPORTER_SELECTION_RESET_FILTERS',
};
